class pgweb.Clock
	clock = null
	timezoneOffset = null
	networkTimezoneOffset = null
	
	@setClock: (time) ->
		clock = time
	
	@setTimezoneOffset: (offset) ->
		timezoneOffset = offset

	@setNetworkTimezoneOffset: (offset) ->
		networkTimezoneOffset = offset

	@setHeaderClock: ->
		data = @clockData timezoneOffset
		$('.clock').html '' # Don't know why this is needed!
		symbol = ''
		tzInfo = ''
		if @networkDiffers()
			symbol = '<i class="fa fa-user"></i> '
			tzInfo = ' ' + data.tzInfo
		$('.clock').html symbol + data.time + tzInfo

	@setNetworkHeaderClock: ->
		data = @clockData networkTimezoneOffset
		$('.networkClock').html '' # Don't know why this is needed!
		$('.networkClock').html '<i class="fa fa-sitemap"></i> ' + data.time + ' ' + data.tzInfo

	@clearNetworkHeaderClock: ->
		$('.networkClock').html ''

	@clockData: (offset) ->
		now = new Date clock*1000
		now = new Date now.getTime() + now.getTimezoneOffset()*60000 + offset*60000
		plusminus = if offset > 0 then '+' else (if offset == 0 then '±' else '')
		tzInfo = plusminus + String(Math.floor(offset/60)).pad(2) + String(offset % 60).pad(2)
		{
			'time': Globalize.format(now, 'd') + ' '+Globalize.format(now, 'T')
			'tzInfo': 'UTC' + tzInfo
		}

	@networkDiffers: ->
		networkTimezoneOffset != '' and networkTimezoneOffset != timezoneOffset and $.url().param().networkId > 0

	@init: ->
		window.setInterval =>
			clock++
			@setHeaderClock()
			if @networkDiffers()
				@setNetworkHeaderClock()
		, 1000

$ ->
	if $('.clock').length > 0
		pgweb.Clock.init()
